<template>
  <div>
    <div class="flex-end font16 baseline">
      <div class="mr15">{{ dateTime.date }}</div>
      <div class="mr15">{{ dateTime.week }}</div>
      <div>{{ dateTime.time }}</div>
    </div>
    <!-- <div>
      <iframe
        width="225"
        height="20"
        frameborder="0"
        scrolling="no"
        hspace="0"
        src="https://i.tianqi.com/?c=code&a=getcode&id=34&icon=1&color=%23FFFFFF&site=10"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
import { getCurDateTime } from '../utils/utils.js'
export default {
  data() {
    return {
      timer: null,
      dateTime: {}
    }
  },
  mounted() {
    this.showDateTime()
  },
  methods: {
    showDateTime() {
      this.timer = setInterval(() => {
        this.dateTime = getCurDateTime()
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
</style>